import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { ComponentDataTable } from '../../../components';
import { debounceIndexProfileSelectionProcessesRequest } from '../../../requests/selectionProcesses';
import columns from './columns';
import './style.scss';

const DEFAULT_CUSTOM_PARAMS = {
  status: 'active',
  filter_process_type: 'internal,mixed'
};

const JobOffersIndex = () => {
  const [courses, setCourses] = useState([]);
  const [amount, setAmount] = useState(0);
  const [onRequest, setOnRequest] = useState(true);

  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();

  const moreData = false;

  const handleSuccessIndex = useCallback(response => {
    const responseCourses = response.data.data;
    const { amount: responseAmount } = response.data.metadata;

    setCourses(camelCaseRecursive(responseCourses));
    setAmount(responseAmount);
    setOnRequest(false);
  }, []);

  const handleIndexRequest = useCallback(
    params => {
      setOnRequest(true);
      const sendParams = { ...params, ...DEFAULT_CUSTOM_PARAMS };

      debounceIndexProfileSelectionProcessesRequest({
        dispatch,
        params: sendParams,
        successCallback: handleSuccessIndex
      });
    },
    [dispatch, handleSuccessIndex]
  );

  const handleButtonClick = (item, action) => {
    if (action === 'show') {
      const token = item.publicUrl.split('/selection_process/public/')[1];
      history.push(`/selection_process/public/${token}`);
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'status':
        return { sort_status: name };
      case 'job_title_name':
        return { sort_job_titles: name };
      case 'job_management_name':
        return { sort_job_managements: name };
      default:
        return { sort_column: name };
    }
  };

  useEffect(() => {
    handleIndexRequest({});
  }, [handleIndexRequest]);

  return (
    <>
      <Row className="my-4">
        <Col>
          <h2 className="m-top mb-3 mt-3">Vacantes Internas</h2>
        </Col>
      </Row>
      <div className="data-table-yellow">
        <ComponentDataTable
          columns={columns(handleButtonClick, user.nationalIdentification)}
          handleSortCase={sortColumnCase}
          totalRows={amount}
          data={courses}
          moreData={moreData}
          onRequest={onRequest}
          resourceRequest={handleIndexRequest}
          customParams={DEFAULT_CUSTOM_PARAMS}
          onRowClicked={item => handleButtonClick(item, 'show')}
          pointerOnHover
        />
      </div>
    </>
  );
};

export default JobOffersIndex;
